module.exports = __webpack_public_path__ + "img/scarf.c97ffe54.svg";